import { ProductType } from 'constants.js';
import { constants } from 'views/Campaign';

const {
  campaignOccurrenceTypes: { ON_DEMAND }
} = constants;

class CurrentTemplate {
  constructor(template, campaign, rule) {
    this.isEventTypeScheduled = template.schemaId === 'static_onDemand';

    this.isAlreadyAssigned = rule
      ? rule.campaignRecipientQueryUuid === template.uuid
      : campaign.campaignRecipientQueryUuid === template.uuid;

    this.isProductTypeSameAsCampaign =
      template.productName === campaign.productName;
    this.isActive = template.active;

    this.isEventTypeSameAsCampaign =
      template.schemaIdentifier === campaign.schemaIdentifier;

    this.isValidListTemplate =
      (template.productType !== ProductType.List &&
        campaign.productType !== ProductType.List) ||
      template.subscriberListId === campaign.subscriberListId;
  }
}

export default (templates = [], thisCampaign, rule) => {
  let results = [];
  if (thisCampaign.campaignOccurrenceType === ON_DEMAND) {
    results = templates.filter(template => {
      const currentTemplate = new CurrentTemplate(template, thisCampaign, rule);
      return (
        currentTemplate.isEventTypeScheduled &&
        currentTemplate.isProductTypeSameAsCampaign &&
        currentTemplate.isEventTypeSameAsCampaign &&
        (currentTemplate.isAlreadyAssigned || currentTemplate.isActive) &&
        currentTemplate.isValidListTemplate
      );
    });
  }
  return results;
};
